import { Routes } from "./routes"
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();

export class RouterObj {
  time: Date = new Date()
  path: string = ""
  title: string = ""
}

export class RouterHistory {
    hist: any[] = [];
    _router_history: any;
    
    create() {
      const h = window.localStorage.getItem("hist")
      if (h) this.hist = JSON.parse(h)
      else this.hist = []
    }

    class () {
      if (!window.router_history) {
        this._router_history = document.createElement("div");
        window.router_history = this;
      } 
      return window.router_history;
    }

    static routes_class:Routes= new Routes();
    static router:any
    
    public get_routes() {
      return RouterHistory.routes_class.get_routes()
    }
  
    public add(r: RouterObj) {
      let add=true;
      if (this.hist.length>0 && this.hist[this.hist.length-1].path == r.path) add = false;

      if (add) {
        this.hist.push(r);
        if (this.hist.length>20) this.hist.shift()
        window.localStorage.setItem("hist", JSON.stringify(this.hist))
      }
    }
  
    public get list() {

      const h = window.localStorage.getItem("hist")
      if (h) this.hist = JSON.parse(h)
      else this.hist = []

      return this.hist;
    }
  }
  